import type { ReportReason } from 'modules/community/types/moderation'

export const REPORT_REASON_VALUES = [
  'harassment',
  'violence',
  'inappropriate_content',
  'spam',
  'fraud',
  'impersonation',
  'prohibited_goods',
  'copyright',
  'other',
] as const satisfies readonly ReportReason[]

export const REPORT_EXPLANATION_MAX_LENGTH = 1000
